import React, {useEffect, useMemo, useState} from 'react';
import { Card, Layout, Button, Row, Col } from 'antd';
import { useClient } from "../../Contexts/ClientContext";
import GoalForm from "./GoalForm";



const Goals = ()=>{
    const [view, setView] = useState('form');

    return (
        <Layout>
            {view === 'form' && (
                <div style={{padding: '5% 10%', margin: 'auto'}}>
                    <GoalForm />
                </div>
            )}
        </Layout>
    )
}

export default Goals;



